import './css/styles.scss';

const STORAGE_KEY = 'femp_ort';

function ortFromUrl(href: string): 'bockara' | 'vaxjo' | null {
  try {
    const u = new URL(href, window.location.origin);
    const seg = u.pathname.split('/').filter(Boolean)[0];
    if (seg === 'bockara' || seg === 'vaxjo') return seg;
    return null;
  } catch {
    return null;
  }
}

function maybeRedirect() {
  if (window.location.pathname !== '/' && window.location.pathname !== '') return;
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved !== 'bockara' && saved !== 'vaxjo') return;

  const panels = document.querySelectorAll<HTMLAnchorElement>('.anlaggningsval__btn');
  for (const a of Array.from(panels)) {
    if (ortFromUrl(a.href) === saved) {
      window.location.replace(a.href);
      return;
    }
  }
}

function bindSave() {
  const panels = document.querySelectorAll<HTMLAnchorElement>('.anlaggningsval__btn');
  panels.forEach((btn) => {
    btn.addEventListener('click', () => {
      const panel = btn.closest('.anlaggningsval__panel');
      const remember = panel?.querySelector<HTMLInputElement>('.anlaggningsval__remember-input');
      if (!remember?.checked) return;
      const ort = ortFromUrl(btn.href);
      if (ort) localStorage.setItem(STORAGE_KEY, ort);
    });
  });
}

function anlaggningsvalInit() {
  maybeRedirect();
  bindSave();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', anlaggningsvalInit);
} else {
  anlaggningsvalInit();
}
